import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration, withEventReplay  } from '@angular/platform-browser';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import { httpErrorInterceptor } from './interceptors/http-error.interceptor';
import { provideServerRendering } from '@angular/platform-server';

export const appConfig: ApplicationConfig = {
  providers: [provideZoneChangeDetection({ eventCoalescing: true }), provideRouter(routes), provideHttpClient(
    withInterceptors([httpErrorInterceptor])
  )]
};
